import React from 'react';

const TOPIC_STATS_METRICS = [
  'Count',
  'AvgDuration',
  'SumDuration'
];

const QUESTION_COUNT_METRICS = [
  'TotalCount',
  'VideoCount',
  'ImageCount',
  'CMSReportCount',
  'BscReportCount'
];

const MetricSelector = React.memo(({ reportType, selectedMetrics, setSelectedMetrics,selectedDimensions }) => {
  const availableMetrics = reportType === 'topicStats' ? TOPIC_STATS_METRICS : QUESTION_COUNT_METRICS;

  const handleCheckboxChange = (metric) => {
    if (selectedMetrics.includes(metric)) {
      setSelectedMetrics(selectedMetrics.filter(m => m !== metric));
    } else {
      setSelectedMetrics([...selectedMetrics, metric]);
    }
  };

  return (
    <div style={{ marginBottom: '16px' }}>
      <h3 style={{ margin: '0 0 8px 0' }}>Metrics</h3>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px' }}>
      {availableMetrics.map(metric => {
  const hasRequiredDimension =
    selectedDimensions &&
    (
      selectedDimensions.includes('AchievementId') ||
      selectedDimensions.includes('AchievementName') ||
      selectedDimensions.includes('AchievementVideoId')
    );

  const shouldDisable =
    reportType === 'topicStats' &&
    (metric === 'AvgDuration' || metric === 'SumDuration') &&
    !hasRequiredDimension;

  return (
    <label key={metric} style={{ display: 'inline-flex', alignItems: 'center' }}>
      <input
        disabled={shouldDisable}
        type="checkbox"
        value={metric}
        checked={selectedMetrics.includes(metric)}
        onChange={() => handleCheckboxChange(metric)}
        style={{ marginRight: '8px' }}
      />
      {metric}
    </label>
  );
})}
      </div>
    </div>
  );
});

export default MetricSelector;
